import { ReactNode, useEffect, useRef } from 'react';
import { Icon, IconButton, Theme, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import { useDrawerContext } from '../contexts';

interface ILayoutBaseDePaginaProps {
    titulo: string;
    children: React.ReactNode
    barraDeFerramentas?: ReactNode;
}

export const LayoutBaseDePagina: React.FC<ILayoutBaseDePaginaProps> = ({ children, titulo, barraDeFerramentas  }) => {
  // CORREÇÃO: Usar breakpoints diferentes para cada variável
  const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm')); // < 600px
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md')); // < 900px
  const theme = useTheme();

  // CORREÇÃO: Consumir mais estados do contexto
  const { toggleDrawerOpen, isDrawerOpen } = useDrawerContext();

  // Refs para armazenar os valores anteriores
  const prevSmDown = useRef(smDown);
  const prevMdDown = useRef(mdDown);

  // Console para monitorar as mudanças de estado específicas
  useEffect(() => {
    // Verifica se smDown mudou
    if (prevSmDown.current !== smDown) {
      prevSmDown.current = smDown;
    }

    // Verifica se mdDown mudou
    if (prevMdDown.current !== mdDown) {
      prevMdDown.current = mdDown;
    }

   
  }, [smDown, mdDown, isDrawerOpen]);



  return (
    <Box height="100%" display="flex" flexDirection="column">
      <Box marginLeft={3} display="flex" alignItems="center" gap={1} height={theme.spacing(smDown ? 6 : mdDown ? 8 : 12)}>
        {/* CORREÇÃO: Agora mostra botão apenas em mobile verdadeiro (<600px) */}
        {smDown && (
          <IconButton onClick={toggleDrawerOpen}>
            <Icon>menu</Icon>
          </IconButton>
        )}

        <Typography
          overflow="hidden"
          whiteSpace="nowrap"
          textOverflow="ellipses"
          // CORREÇÃO: Lógica corrigida para variantes de título
          variant={smDown ? 'h5' : mdDown ? 'h4' : 'h3'}
        >
          {titulo}
        </Typography>
      </Box>

      {barraDeFerramentas && (
        <Box>
          {barraDeFerramentas}
        </Box>
      )}

      <Box marginX={1} marginBlockEnd={2}>
        {children}
      </Box>
    </Box>
  );
};